import { Modal, Button, Form } from "react-bootstrap";
import { InputSelect, InputText } from "@2solve/tosolve-inputs";

function EditGroupModal({
  show,
  onHide,
  onSubmit,
  newName,
  setNewName,
  error,
  newDescription,
  setNewDescription,
  newStrategy,
  setNewStrategy,
  strategyOptions,
  t,
}) {
  return (
    <Modal size="lg" backdrop="static" centered show={show} onHide={onHide}>
      <Modal.Header closeVariant="white" closeButton>
        <Modal.Title>Editar Codec</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={onSubmit}>
          <InputText
            id="editMappingGroupName"
            type="text"
            placeholder={t("Digite o novo nome")}
            value={newName}
            onChange={(_, value) => setNewName(value)}
          />
          <InputText
            className="mt-4"
            id="editMappingGroupDescription"
            type="text"
            placeholder={t("Digite a nova descrição")}
            value={newDescription}
            onChange={(_, value) => setNewDescription(value)}
          />
          <InputSelect
            className="mt-4"
            placeholder={t("Estratégia de decodificação")}
            id="decoding_strategy_id"
            type="select"
            options={strategyOptions}
            isMultiple={false}
            selectAll={false}
            closeOnSelect={true}
            IsClearable={false}
            disabled={false}
            onChange={(_, value) => setNewStrategy(value)}
            value={newStrategy || ""} // Valor controlado pelo estado
          />
          {error && <div className="text-danger">{error}</div>}
          <Modal.Footer>
            <Button variant="primary" type="submit">
              {t("button_save")}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default EditGroupModal;
